import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Tooltip } from 'tdesign-react';
import { isSuperAdmin } from '.';

/** 弹框专用，展示环境下不允许操作
 * @param {import ('tdesign-react').ButtonProps} props
 * */
export default function useDisableButton(props) {
  const roles = useSelector((state) => state.auth.roles || []);
  const superAdmin = isSuperAdmin(roles);

  return superAdmin ? (
    props
  ) : (
    <Tooltip content='体验环境暂不支持该功能'>
      <Button disabled {...props} />
    </Tooltip>
  );
}
